import { Component, OnInit, OnDestroy } from '@angular/core';

import { FirebaseMessagingService } from '../../../core/service/firebase-messaging.service';
import { shareReplay, Subscription } from 'rxjs';
import { NotificationsService } from '../notifications/service/notifications.service';

@Component({
  selector: 'shared-push-notification',
  standalone: true,
  imports: [],
  templateUrl: 'push-notifcations.component.html',
  styles: []
})
export class PushNotificationDemoComponent implements OnInit, OnDestroy {
  permissionGranted = false;
  lastMessage: any = null;
  private messageSubscription?: Subscription;

  constructor(private firebaseMessaging: FirebaseMessagingService, private notificacionService: NotificationsService) { }

  ngOnInit() {
    this.checkPermissionStatus();
    this.subscribeToMessages();
  }

  ngOnDestroy() {
    if (this.messageSubscription) {
      this.messageSubscription.unsubscribe();
    }
  }

  private checkPermissionStatus() {
    this.permissionGranted = Notification.permission === 'granted';
  }

private subscribeToMessages() {
  this.messageSubscription = this.firebaseMessaging.getMessages().pipe(
    shareReplay(1)
  ).subscribe(message => {

    this.lastMessage = message;

    this.notificacionService.addNotification({
      message: message.notification?.body || 'Nueva notificación recibida',
      type: 'warning',
      autoClose: false
    });
  });
}

  async requestPermission() {
    try {
      const permission = await Notification.requestPermission();
      this.permissionGranted = permission === 'granted';

      if (this.permissionGranted) {
        // Instalar el service worker de Firebase
        await this.firebaseMessaging.installFVMServiceWorker();
      } else {

      }
    } catch (error) {

    }
  }

  testNotification() {
    if (this.permissionGranted) {
      // Crear una notificación de prueba
      const notification = new Notification('Notificación de Prueba', {
        body: 'Esta es una notificación de prueba desde la aplicación',
        icon: '/icons/icon-192x192.png',
        badge: '/icons/icon-72x72.png',
        tag: 'test-notification'
      });

      notification.onclick = () => {
        window.focus();
        notification.close();
      };

      setTimeout(() => {
        notification.close();
      }, 5000);
    } else {

    }
  }
}
